<template>
    <div>
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>集成采购合同</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <swb-comn-contract-list name="contract_list" :domHeight="domHeight" :contractType="contractType" :merchant="merchant" :path="path" :thisPath="thisPath" :currentRealComId="currentRealComId" ref="swb_comn_contract_list"></swb-comn-contract-list>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes, DomSizeWatcher } from '../../app.vues'

    import SwbRegisterIntegPurchContract from './RegisterIntegPurchContract';
    Routes.add(SwbRegisterIntegPurchContract);
    //
    import SwbComnContractList from './ComnContractList';
    Vue.regist(SwbComnContractList);

    export default {
        name: 'swb-integ-purch-contract-list',
        path: '/integ/purch/contract/list',
        pathOld: '/integ/purch/contract/page/list',
        avlActions: '',
        avlActionNames: '添加合同、编辑、申请审核、搜索标签、设置标签、加入备选供方、来源管理、站内信、审核确认、作废、变更、订商品、订服务、查看商品订单、查看服务订单、履约审核、验收',
        avlScopes: 'retailer',
        desc: '集成采购合同',
        helpArticleCode: 'retailer-integ-purch-contract-list',
        data: function () {
            return {
                contractType: 3,
                merchant: '服务商',
                path: SwbRegisterIntegPurchContract.path,
                thisPath: Vue.$getClassInfo(this).path,
                currentRealComId: null,
                domHeight: 700
            }
        },
        created: function () {
            this.currentRealComId = this.$route.query.currentRealComId || null;
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            $(this.$el).addClass('overflow-hidden');
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('[name="contract_list"]'), function (width, height, theEl) {
                //根据新主元素的内容大小，调整表格高度
                self.domHeight = height;
                console.log("qw" + height);
            });
            //domSizeWatcher.setHrEls();
            domSizeWatcher.setVtEls(thisEl.find('.breadcrumb-layout'));
            domSizeWatcher.start(500);
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {}
    }
</script>




// WEBPACK FOOTER //
// src/compo/contract/IntegPurchContractList.vue